import { render, staticRenderFns } from "./NichesSvgsHeader.vue?vue&type=template&id=441bb63f"
import script from "./NichesSvgsHeader.vue?vue&type=script&lang=js"
export * from "./NichesSvgsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports